var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"btn btn-secondary btn-sm",attrs:{"href":'/'+_vm.url+'?client='+_vm.client}},[_vm._v(_vm._s(_vm.total))])])
}
var staticRenderFns = []

export { render, staticRenderFns }